// JobApplicationContext.tsx
import React, { createContext, useContext, useState } from "react";

type JobApplicationContextType = {
  isAddingStep: boolean;
  setIsAddingStep: React.Dispatch<React.SetStateAction<boolean>>;
  isReorderSelection: boolean;
  setIsReorderSelection: React.Dispatch<React.SetStateAction<boolean>>;
};

const JobApplicationContext = createContext<
  JobApplicationContextType | undefined
>(undefined);

export const JobApplicationProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isAddingStep, setIsAddingStep] = useState(false);
  const [isReorderSelection, setIsReorderSelection] = useState(false);

  return (
    <JobApplicationContext.Provider
      value={{
        isAddingStep,
        setIsAddingStep,
        isReorderSelection,
        setIsReorderSelection,
      }}
    >
      {children}
    </JobApplicationContext.Provider>
  );
};

export const useJobApplicationContext = () => {
  const context = useContext(JobApplicationContext);
  if (!context)
    throw new Error(
      "useJobApplicationContext must be used within a JobApplicationProvider",
    );
  return context;
};
